<template>
  <div class="weather-container">
    <img v-if="isWind" title="风" class="weather-icon" src="../../assets/png/wind-blue.png" @click="removeWeatherLayers()" />
    <img v-if="!isWind" title="风" class="weather-icon" src="../../assets/png/wind-gray.png" @click="changeWeatherLayer('wind')" />
    <img v-if="isCurrent" title="洋流" class="weather-icon" src="../../assets/png/current-blue.png" @click="removeWeatherLayers()"/>
    <img v-if="!isCurrent" title="洋流" class="weather-icon" src="../../assets/png/current-gray.png" @click="changeWeatherLayer('current')"/>
    <img v-if="isWaves" title="海浪" class="weather-icon" src="../../assets/png/wave-blue.png" @click="removeWeatherLayers()" />
    <img v-if="!isWaves" title="海浪" class="weather-icon" src="../../assets/png/wave-gray.png" @click="changeWeatherLayer('wave')" />
    <img  v-if="!showPressure" title="气压线" class="weather-icon" src="@/assets/png/pressure-normal-2x.png" @click="showPressureLayer" />
    <img  v-if="showPressure" title="气压线" class="weather-icon" src="@/assets/png/pressure-click-2x.png" @click="hidePressureLayer" />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { Factor } from '../../utils/colorMap'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { MapboxStyle } from '@/lib/extension'
import { MapboxLayer } from '@/lib/layer'
import { Resource } from "cesium"
import { Cartesian2, Cartesian3, Color, HorizontalOrigin, LabelStyle } from 'cesium'

export default defineComponent({
  name: 'WeatherBar',
  components: {},
  props: {
    viewer: {
      type: Object,
      default: () => { return null }
    },
    showWeatherIcons: {
      type: Boolean,
      default: () => { return null }
    },
    isRotation: {
      type: Boolean,
      default: () => { return null }
    },
    changeRotation: {
      type: Function,
      default: () => { return null }
    },
    clientWidth: {
      type: Number,
      default: () => { return null }
    },
    lonlat: {
      type: Array,
      default: () => { return null }
    }
  },
  data () {
    return {
      windRasterUrls: [],
      waveRasterUrls: [],
      currentRasterUrls: [],
      windParcticleUrls: [],
      currentParcticleUrls: [],
      weatherPrimitives: {},
      presssureJsonUrls: [],
      Practicle: null,
      isWind: false,
      isWaves: false,
      isCurrent: false,
      isParticle: false,
      showPressure: false,
      pressureLayer: null,
      colorArray: [],
      croodValueBillboard: null,
      url: null
    }
  },
  mounted () {
    // console.log(this.clickedIndex)
    this.getRasterUrls()
    this.getPressureData()
    setInterval(() => {
       this.getRasterUrls()
    }, 60 * 60 * 1000)
  },
  watch: {
    clickedIndex: {
      handler: function(newValue) {
        if (this.isWind) {
          if (this.isPlay) {
            this.removePracticle()
            this.addWindLayer()
          } else {
            this.updateWeatherLayer('wind')
          }
          if (newValue && this.lonlat && this.lonlat.length > 0 && this.colorArray && this.colorArray.length > 0) {
            const value = this.getcroodValue(this.lonlat, this.colorArray, 'wind')
            this.addcroodValueEntity(this.viewer, this.lonlat, value, '风速')
          } else {
            this.removecroodValueEntity()
          }
        } else if (this.isWaves) {
          if (this.isPlay) {
            this.removePracticle()
            this.addWaveLayer()
          } else {
            this.updateWeatherLayer('wave')
          }
          if (newValue && this.lonlat && this.lonlat.length > 0 && this.colorArray && this.colorArray.length > 0) {
            const value = this.getcroodValue(this.lonlat, this.colorArray, 'waves')
            this.addcroodValueEntity(this.viewer, this.lonlat, value, '海浪')
          } else {
            this.removecroodValueEntity()
          }
        } else if (this.isCurrent) {
          if (this.isPlay) {
            this.removePracticle()
            this.addCurrentLayer()
          } else {
            this.updateWeatherLayer('current')
          }
          if (newValue && this.lonlat && this.lonlat.length > 0 && this.colorArray && this.colorArray.length > 0) {
            const value = this.getcroodValue(this.lonlat, this.colorArray, 'seacurrents')
            this.addcroodValueEntity(this.viewer, this.lonlat, value, '洋流')
          } else {
            this.removecroodValueEntity()
          }
        } else {
          return 
        }
      },
      deep: true
    },
    isPlay: {
      handler: function(newValue) {
        if (newValue) {
          this.removePracticle()
        }
      }
    },
    lonlat: {
      handler: function(newcrood) {
  
        let value = null
        if (this.isWind) {
          value = this.getcroodValue(newcrood, this.colorArray, 'wind')
          this.addcroodValueEntity(this.viewer, newcrood, value, '风速')
        } else if (this.isCurrent) {
          value = this.getcroodValue(newcrood, this.colorArray, 'seacurrents')
          this.addcroodValueEntity(this.viewer, newcrood, value, '洋流')
        } else if  (this.isWaves) {
          console.log('经纬度', newcrood)
          value = this.getcroodValue(newcrood, this.colorArray, 'waves')
          this.addcroodValueEntity(this.viewer, newcrood, value, '海浪')
        } else {
          return
        }
      },
      deep: true
    },
    isWind: function(newValue) {
      this.SET_IS_WIND(newValue)
      if (newValue && this.lonlat && this.lonlat.length > 0 && this.colorArray && this.colorArray.length > 0) {
        const value = this.getcroodValue(this.lonlat, this.colorArray, 'wind')
        this.addcroodValueEntity(this.viewer, this.lonlat, value, '风速')
      } else {
        this.removecroodValueEntity()
      }
    },
    isCurrent: function(newValue) {
      this.SET_IS_CURRENT(newValue)
      if (newValue && this.lonlat && this.lonlat.length > 0 && this.colorArray && this.colorArray.length > 0) {
        const value = this.getcroodValue(this.lonlat, this.colorArray, 'seacurrents')
        this.addcroodValueEntity(this.viewer, this.lonlat, value, '洋流')
      } else {
        this.removecroodValueEntity()
      }
    },
    isWaves: function(newValue) {
      this.SET_IS_WAVE(newValue)
      if (newValue && this.lonlat && this.lonlat.length > 0 && this.colorArray && this.colorArray.length > 0) {
        const value = this.getcroodValue(this.lonlat, this.colorArray, 'waves')
        this.addcroodValueEntity(this.viewer, this.lonlat, value, '海浪')
      } else {
        this.removecroodValueEntity()
      }
    },
    showWeatherIcons: function(newValue) {
      // console.log(newValue)
      if (!newValue) {
        this.removeWeatherLayers()
      }
    },
    isRotation: function(newValue) {
      // console.log(newValue)
      if (newValue) {
        this.removePracticle()
      }
    }
  },
  computed: {
    ...mapGetters(['timeGrid', 'isPlay']),
    utcdate () {
      const localdate = new Date()
      const localoffset = localdate.getTimezoneOffset() / 60
      
      // utcdate
      const utcdate = moment(localdate).add(localoffset, 'h').format('yyyy/MM/DD/0HH')
      const utchour = Number(utcdate.slice(12, 14))
      const offhour = utchour % 3 === 0 ? utchour : utchour - utchour % 3
      const hourstr = offhour < 10 ? '0' + offhour : offhour
      const utcdateStr = utcdate.slice(0, 12) + hourstr
      return utcdateStr
      // return '2021/12/07/021'
    },
    clientWidthScale () {
      return this.clientWidth / 1000
    },
    clickedIndex () {
      return Math.floor(this.timeGrid / 3)
    }
  },
  methods: {
    ...mapActions(['SET_IS_WIND', 'SET_IS_WAVE', 'SET_IS_CURRENT']),
    getDate (temp) {
      const localdate = new Date()
      const localoffset = localdate.getTimezoneOffset() / 60
      // console.log(localoffset + temp)
      // utcdate
      const utcdate = moment(localdate).add(localoffset + temp, 'h').format('yyyy/MM/DD/0HH')
      const utchour = Number(utcdate.slice(12, 14))
      // console.log(utchour)
      const offhour = utchour % 3 === 0 ? utchour : utchour - utchour % 3
      const hourstr = offhour < 10 ? '0' + offhour : offhour
      const utcdateStr = utcdate.slice(0, 12) + hourstr
      return utcdateStr
      // return '2021/12/07/021'
    },
    getRasterUrls() {
      // 清空
      this.windRasterUrls = []
      this.waveRasterUrls = []
      this.currentRasterUrls = []
      this.windParcticleUrls = []
      this.currentParcticleUrls = []
      // 调用栅格图片url地址接口
      const today = new Date()
      const today00 = new Date(today.setHours(0, 0, 0, 0))
      const utcToday = moment(today00).utc()
      const gate = 'http://cfdt.ninecosmos.cn/meteo-open'
      const hours = ['000', '003', '006', '009', '012', '015', '018', '021', 'avg', 'min', 'max', 'sum']
      const hoursW = ['00', '03', '06', '09', '12', '15', '18', '21', 'avg', 'min', 'max', 'sum']
      // const epsg = '3857'
      // const source = 's02'
      this.z = 3
      const dayLength = 9
      const hourLength = 8
      for (let i = 0; i < dayLength; i++) {
        for (let j = 0; j < hourLength; j++) {
          const day = moment(utcToday).add(24 * i, 'h').format('yyyy/MM/DD')
          if (!((i === 0 && j < 5) || (i === dayLength - 1 && j > 5))) {
            this.windRasterUrls.push(gate + '/' + 's01' + '/' + day + '/' + hours[j] + '/wind-surface-4326.png')
            this.waveRasterUrls.push(gate + '/' + 's02' + '/' + day + '/' + hours[j] + '/waves-surface-4326.png')
            this.currentRasterUrls.push(gate + '/' + 's02' + '/' + day + '/' + hours[j] + '/seacurrents-surface-4326.png')
            //this.windParcticleUrls.push(gate + '/' + 's01' + '/' + day + '/' + hours[j] + '/wind-surface-4326-1p.json')
            this.windParcticleUrls.push(`http://cfdt.ninecosmos.cn/air/zte/wind/${day}/${hoursW[j]}.json`)
            this.currentParcticleUrls.push(gate + '/' + 's02' + '/' + day + '/' + hours[j] + '/seacurrents-surface-4326.png')
          }
        }
      }
      // console.log(this.windRasterUrls)
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var ext = img.src.substring(img.src.lastIndexOf(".")+1).toLowerCase();
      var dataURL = canvas.toDataURL("image/"+ext);
      // console.log(dataURL)
      return dataURL;
    },
    loadRasterLayer(url, factor) {
      // axios({
      //   method: 'get',
      //   url: url,
      //   dataType: "image",
      //   crossDomain: true,
      //   cache: false
      // }).then(res => {
        
        var image = new Image();
        image.setAttribute('crossOrigin', 'anonymous');
        image.src = this.url;
        image.onload = () => {
          const base64 = this.getBase64Image(image);
          // console.log(base64);
          // 创建canvas，获取单点值
          this.creatCanvas()
          // 渲染图片
          if (!this.weatherPrimitives || this.weatherPrimitives.length === {}) {
            const primitive = this.viewer.createColorMapPrimitive({
              url: url,
              factor: factor
            })
            this.weatherPrimitives = this.viewer.addPrimitive(primitive, 'weather-primitive')
          } else {
            this.viewer.changePrimitiveMaterial(this.weatherPrimitives, base64)
          }  
        } 
      // }).catch(error => {
      // })
    },
    addWindLayer () {
      this.url = this.windRasterUrls[this.clickedIndex]
      this.loadRasterLayer(this.url, 'Wind')
    },
    addWaveLayer () {
      this.url = this.waveRasterUrls[this.clickedIndex]
      this.loadRasterLayer(this.url, 'Waves')
    },
    addCurrentLayer () {
      this.url = this.currentRasterUrls[this.clickedIndex]
      this.loadRasterLayer(this.url, 'SeaCurrents')
    },
    removeWeatherLayers () {
      this.isWind = false
      this.isWaves = false
      this.isCurrent = false
      this.viewer.removePrimitive(this.weatherPrimitives)
      this.weatherPrimitives = null
      this.viewer.removeCustomPracticle()
      if(this.croodValueBillboard) {
        this.viewer.removeEntity(this.croodValueBillboard)
      }
    },

    removePracticle() {
      this.viewer.removeCustomPracticle()
    },
    addWindPracticle () {
      if (this.isRotation) {
        this.changeRotation(this.viewer)
      }

      this.viewer.removeCustomPracticle()
      const lineWidth = this.clientWidth <= 1921 ? 0.6 : 1.6
      const windOptions = {
        maxAge: 200,
        lineWidth: lineWidth, // 绘制粒子的线宽
        globalAlpha: 0.92, // 透明度
        velocityScale: 1/60, // 风速的比例 ( 粒子的小尾巴长度 )
        frameRate: 15, // 每秒所需的帧数
        paths: 7000
      }
      const url = this.windParcticleUrls[this.clickedIndex]
      fetch(url)
        .then(response => response.json())
        .then((json) => {
          this.viewer.addCustomPracticle(json, windOptions)
        })
    },
    addCurrentPracticle () {
      if (this.isRotation) {
        this.changeRotation(this.viewer)
      }

      this.viewer.removeCustomPracticle()
      const lineWidth = this.clientWidth <= 1921 ? 0.6 : 1.6

      const currentOptions = {
        maxAge: 15, // 粒子存活帧数
        lineWidth: lineWidth, // 绘制粒子的线宽
        globalAlpha: 0.92, // 透明度
        velocityScale: 1/6, // 速度的比例 ( 粒子的小尾巴长度 )
        frameRate: 15, // 每秒所需的帧数
        paths: 6000
      }
      const url = this.currentParcticleUrls[this.clickedIndex]
      this.drawByImage(url, currentOptions)
    },
    drawByImage(url, options) {
      const image = new Image();
      image.setAttribute('crossOrigin', 'Anonymous');
      image.onload = () => {
        const json = this.getVectorJsonFromImage(image, Factor.SeaCurrents);
        const data1 = json[0].data;
        const data2 = json[1].data;
        for (let i = 0, l = data1.length; i < l; i++) {
          if (data1[i] === -2.5 && data2[i] === -2.5) {
            data1[i] = null;
            data2[i] = null;
          }
        }
        const jsonData = json;
        this.viewer.addCustomPracticle(jsonData, options)
      }
      image.src = url
    },
    getVectorJsonFromImage(image, factor) {
      const c = document.createElement('canvas');
      c.width = image.width;
      c.height = image.height;
      const ctx = c.getContext('2d');
      ctx.drawImage(image, 0, 0);
      const data = ctx.getImageData(0, 0, c.width, c.height).data;
      const nx = 1441
      const header1 = {
        'nx': nx,
        'ny': 721,
        'lo1': -180,
        'la1': 90,
        'lo2': 179.75,
        'la2': -90,
        'dx': 0.25,
        'dy': 0.25,
        'parameterCategory': 2,
        'parameterNumber': 2,
      };
      const header2 = {
        'nx': nx,
        'ny': 721,
        'lo1': -180,
        'la1': 90,
        'lo2': 179.75,
        'la2': -90,
        'dx': 0.25,
        'dy': 0.25,
        'parameterCategory': 2,
        'parameterNumber': 3,
      };
      const data1 = [];
      const data2 = [];
      for (let i = 0, dl = data.length / 4; i < dl; i++) {
        const index = i * 4;
        const cr = data[index];
        const cg = data[index + 1];
        if (factor === Factor.Wind) {
          data1[i] = -25 + cr * 0.2;
          data2[i] = -25 + cg * 0.2;
        } else if (factor === Factor.SeaCurrents) {
          if (cr === 0 && cg === 0) {
            data1[i] = null;
            data2[i] = null;
          } else {
            data1[i] = -5 + cr * 0.04;
            data2[i] = -5 + cg * 0.04;
          }
        }
      }
      return [
        {
          header: header1,
          data: data1,
        },
        {
          header: header2,
          data: data2,
        },
      ];
    },
    updateWeatherLayer(target) {
      if (target === 'wind') {
        this.isWind = true
        this.addWindLayer() 
        this.addWindPracticle()
      } else if (target === 'wave') {
        this.isWaves = true
        this.viewer.removeCustomPracticle()
        this.addWaveLayer()
      } else if (target === 'current') {
        this.isCurrent = true
        this.addCurrentLayer()
        this.addCurrentPracticle()
      } else {
        return false
      }
    },
    changeWeatherLayer(target) {
      this.removeWeatherLayers()
      this.viewer.removeCustomPracticle()
      this.updateWeatherLayer(target)
    },

    clearWeatherLayer() {
      this.viewer.removePrimitive(this.weatherPrimitives)
      this.weatherPrimitives = null
      this.viewer.removeCustomPracticle()
    },

    resetWeatherLayer(mapType) {
      if(this.isWind) {
        this.addWindLayer() 
        if(mapType === '3d') {
          this.addWindPracticle()
        }
      }else if(this.isWaves) {
        this.addWaveLayer()
      }else if(this.isCurrent) {
        this.addCurrentLayer()
        if(mapType === '3d') {
          this.addCurrentPracticle()
        }
      }
    },

    creatCanvas() {
      const img = new Image();
      img.crossOrigin = 'anonymous' // 解决json跨域
      img.src = this.url;
      img.onload = () => {

        const weatherCanvas = document.getElementsByClassName('weather-canvas')
        if (weatherCanvas && weatherCanvas.length > 0) {
          weatherCanvas.forEach(dom => {
            dom.parent.remove(dom)
          })
        }

        const canvas = document.createElement('canvas')
        canvas.className = 'weather-canvas'
        canvas.id = 'weather-canvas';
        canvas.width = img.width;
        canvas.height = img.height;
        const cxt = canvas.getContext("2d");
        cxt.drawImage(img, 0, 0, img.width, img.height);
        const imgData = cxt.getImageData(0,0,img.width, img.height);
        this.colorArray = imgData.data
      }
    },
    colorToValue (target, r, g) {
      let value = null
      if (target === 'wind') {
        let redColor = r;
        let redValue =  0.2 * redColor -25
        let greenColor = g;
        let greenValue = 0.2 * greenColor -25
        const _value = Math.sqrt(redValue * redValue + greenValue * greenValue)
        value = (_value / 0.5144).toFixed(1) + ' knots'
      } else if (target === 'seacurrents') {
        let redColor = r;
        let redValue =  0.02 * redColor - 2.5
        let greenColor = g;
        let greenValue = 0.02 * greenColor - 2.5
        const _value = Math.sqrt(redValue * redValue + greenValue * greenValue)
        const __value = (_value / 0.5144).toFixed(1) + ' knots'
        value = __value === '3.5' ? '-' : __value
      } else if (target === 'temp') {
        value  = r * 0.5 - 70
      } else if (target === 'humidity') {
        value = r * 0.5
      }  else if (target === 'precipitation') {
        const log = r / 16;
        const logMin = Math.floor(log);
        let minV = 0;
        if (logMin > 0) minV = 2 ** (logMin + 3);
        const maxV = 2 ** (logMin + 4);
        const minR = logMin * 16;
        const vp = (maxV - minV) / 16;
        return ((r - minR) * vp + minV) / 10;
      } else if (target === 'precipAvgPer') {
        value = r * 2 - 100
      } else if (target === 'soilMoisture') {
        value = r * 4
      }  else if (target === 'sst') {
        value = r > 0 ? (r * 0.2 - 10).toFixed(0) : '-'
      } else if (target === 'pressure') {
        value = (r * 100 + 90000) / 100
      } else if (target === 'waves') {
        value = (r * 0.05).toFixed(2) + ' m'
      } else {
        return false
      }
      return value
    },
    getcroodValue (crood, colorArray, type) {
        const lon = crood[0]
        const lat = crood[1]
        const x = Math.floor(1440 * (lon + 180) / 360)
        const y = Math.floor(721 * (90 - lat) / 180)
        const i = 4 * (1441 * y + x)
        const r = colorArray[i]
        const g = colorArray[i + 1]
        const value = this.colorToValue(type, r, g )
        //  console.log(lon, lat, x, y, i, r, g, value)
        return value
    },
    addcroodValueEntity (viewer, crood, value, name) {
      // console.log(this.clientWidthScale / 5)
      this.removecroodValueEntity()

      const point = crood || []
      const bgWidth = 4
      const bgHeight = 128
      const billboardscale = this.clientWidthScale / 4
      const labelscale = this.clientWidthScale / 6
      const billboardOffset = bgWidth * billboardscale / 2
      // const labelOffsetX = bgWidth * billboardscale / 6
      const labelOffsetY = bgHeight * billboardscale * 2 / 3
      const paddingX = this.clientWidthScale * 20 < 60 ? this.clientWidthScale * 20 : 60
      const paddingY = this.clientWidthScale * 12 < 36 ? this.clientWidthScale * 12 : 36


      this.croodValueBillboard = viewer.addEntity({
        position: Cartesian3.fromDegrees(point[0], point[1], 10000),
        billboard: {
          image: './png/crood-line-bg.png',
          scale: billboardscale,
          verticalOrigin: HorizontalOrigin.LEFT,
          pixelOffset: new Cartesian2(billboardOffset, 0),
          eyeOffset: new Cartesian3(0,0,5)
        },
        label: {
          id: 'croodValue',
          text: name + '：\n' + value,
          font: '44px sans-serif',
          scale: labelscale,
          // style: LabelStyle.FILL,
          fillColor: Color.WHITE,
          showBackground: true,
          backgroundPadding: new Cartesian2(paddingX, paddingY),
          horizontalOrigin: HorizontalOrigin.LEFT,
          pixelOffset: new Cartesian2(0, -labelOffsetY),
          eyeOffset: new Cartesian3(0, 0, 5)
        }
      }, 'croodValue')
    },
    removecroodValueEntity() {
      if (this.croodValueBillboard) {
        this.viewer.removeEntity(this.croodValueBillboard)
      }
    },
    getPressureData() {
            const today = new Date()
            const today00 = new Date(today.setHours(0, 0, 0, 0))
            const utcToday = moment(today00).utc()
            const gate = 'http://cfdt.ninecosmos.cn/meteo-open'
            const hours = ['000', '003', '006', '009', '012', '015', '018', '021', 'avg', 'min', 'max', 'sum']
            // const epsg = '3857'
            const source = 's01'
            const dayLength = 9
            const hourLength = 8
            for (let i = 0; i < dayLength; i++) {
                for (let j = 0; j < hourLength; j++) {
                    const day = moment(utcToday).add(24 * i, 'h').format('yyyy/MM/DD')
                    if (!((i === 0 && j < 5) || (i === dayLength - 1 && j > 5))) {
                        const url = gate + '/' + source + '/' + day + '/' + hours[j] + '/pressure-surface-4326-isoline.json'
                        this.presssureJsonUrls.push(url)
                    }
                }
            }
        },
        showPressureLayer() {
            this.showPressure = true
            this.fetchPressureJsonData()
        },
        fetchPressureJsonData() {
            if(!this.showPressure || this.isPlay) {
                return
            }
            this.currentIndex = Math.floor(this.timeGrid / 3)
            const currentUrl = (this.presssureJsonUrls && this.presssureJsonUrls.length > 0 ? this.presssureJsonUrls[this.currentIndex] : '')
            Resource.fetchJson({
                url: currentUrl
            }).then(jsonData => {
                this.addPressureLayer(jsonData)
            })
        },
        addPressureLayer(json) {
          let style = new MapboxStyle({
              name: 'jiufang-pressure',
              glyphs: 'https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf'
          })
          style.setLayers([
              {
                  "id": "pressureLine",
                  "type": "line",
                  "source": "pline-source",
                  "layout": {
                      "line-join": "round",
                      "line-cap": "round"
                  },
                  "paint": {
                      "line-color": "rgba(235,235,235, 1)",
                      "line-width": {
                          "stops": [
                              [4, 1],
                              [7, 3]
                          ]
                      },
                      "line-opacity": 1
                  }
              },
              {
                  "id": "pressureLabel",
                  "type": "symbol",
                  "source": "pline-source",
                  "layout": {
                      "symbol-placement": "line",
                      "text-field": "{value}",
                      "text-size": {
                          "stops": [
                              [4, 12],
                              [7, 20]
                          ]
                      }
                  },
                  "paint": {
                      "text-color": "rgba(235,235,235, 1)"
                  }
              },
              {
                  "id": "pressureHL",
                  "type": "symbol",
                  "source": "pline-source",
                  "filter": ["==", ["geometry-type"], "Point"],
                  "layout": {
                      "symbol-placement": "point",
                      "text-field": "{type}\n{value}",
                      "text-size": 12
                  },
                  "paint": {
                      "text-color": "#fff",
                      "text-halo-blur": 1,
                      "text-halo-color": "#444",
                      "text-halo-width": 0.2
                  }
              }
          ])

          style.setSources({
              "pline-source": {
                  type: 'geojson',
                  data: json
              }
          })

          if(this.pressureLayer) {
              this.pressureLayer.remove()
              this.pressureLayer = null
          }
          this.pressureLayer = new MapboxLayer(style.getStyleJSON())
          this.pressureLayer.addTo(this.viewer.getViewer())
      },
      hidePressureLayer() {
          this.pressureLayer.remove()
          this.pressureLayer = null
          this.showPressure = false
      },
  }
})
</script>

<style lang="scss">

  @import '../../styles/variables';

  @media screen and (max-width: 1920px) {
    .weather-container {
      display: flex;
      flex-direction: column;
      align-items: end;
      justify-content: flex-end;
      background: rgba(0,0,0,0.4);
      width: 32px;
      margin-left: 2px;

      .weather-icon {
        height: $icon-height-1920;
        width: $icon-width-1920;
        cursor: pointer;
        box-sizing: border-box;
        margin: 5px 0;
        color: #ffffff;
        
      }
    }
  }

  @media screen and (min-width: 1921px) {
    .weather-container {
      display: flex;
      flex-direction: column;
      align-items: end;
      justify-content: flex-end;
      background: rgba(0,0,0,0.4);

      .weather-icon {
        height: $icon-height-2560;
        width: $icon-width-2560;
        cursor: pointer;
        box-sizing: border-box;
        margin: 5px 0;
        color: #ffffff;
      }

    }
  }

  @media screen and (min-width: 2561px) {
    .weather-container {
      display: flex;
      flex-direction: column;
      align-items: end;
      justify-content: flex-end;

      .weather-icon {
        height: $icon-height-4368;
        width: $icon-width-4368;
        cursor: pointer;
        box-sizing: border-box;
        margin: 10px 0;
        color: #ffffff;
      }

    }
  }

  @media screen and (min-width: 6700px) {
    .weather-container {
      display: flex;
      flex-direction: column;
      align-items: end;
      justify-content: flex-end;

      .weather-icon {
        height: $icon-height-6720;
        width: $icon-width-6720;
        cursor: pointer;
        box-sizing: border-box;
        margin: 10px 0;
        color: #ffffff;
      }

    }
  }
  
</style>
